import { TermsOfServiceModal } from './TermsOfServiceModal';

export default TermsOfServiceModal;
export { TermsOfServiceModal };
